export default [
  {
    label: '卫星',
    type: 'satellite',
    key: 0,
    icon: 'icon-weixing-1',
    clidren: [
      {
        label: '<span>卫星云图</span>',
        type: 'H8',
        fn: 'historyLayerShow',
        param: 'H8',
        icon: 'icon-yaoganyaoce',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>AOD</span>',
        type: 'AOD',
        fn: 'historyLayerShow',
        param: 'AOD',
        icon: 'icon-yaoganyaoce',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>PM<sub>2.5</sub></span>',
        type: 'PM25',
        fn: 'historyLayerShow',
        param: 'satellitePM25',
        icon: 'icon-daikouzhao',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>PM<sub>10</sub></span>',
        type: 'PM10',
        fn: 'historyLayerShow',
        param: 'satellitePM10',
        icon: 'icon-PM',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>SO<sub>2</sub></span>',
        type: 'SO2',
        fn: 'historyLayerShow',
        param: 'satelliteSO2',
        icon: 'icon-SO-',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>NO<sub>2</sub></span>',
        type: 'NO2',
        fn: 'historyLayerShow',
        param: 'satelliteNO2',
        icon: 'icon-NO2',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>O<sub>3</sub></span>',
        type: 'O3',
        fn: 'historyLayerShow',
        param: 'satelliteO3',
        icon: 'icon-satellite-O3',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>CO</span>',
        type: 'CO',
        fn: 'historyLayerShow',
        param: 'satelliteCO',
        icon: 'icon-wuranyuan',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>O<sub>3</sub>柱</span>',
        type: 'O3_ZHU',
        fn: 'historyLayerShow',
        param: 'satelliteO3_ZHU',
        icon: 'icon-chouyang-mian',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>CO<sub>2</sub></span>',
        type: 'CO2',
        fn: 'historyLayerShow',
        param: 'satelliteCO2',
        icon: 'icon-co2',
        parent: 'satellite',
        isSelected: false,
      },
      {
        label: '<span>CH<sub>4</sub></span>',
        type: 'CH4',
        fn: 'historyLayerShow',
        param: 'satelliteCH4',
        icon: 'icon-CH4',
        parent: 'satellite',
        isSelected: false,
      },
    ],
  },
  {
    label: '站点',
    type: 'pm',
    key: 1,
    icon: 'icon-diqiu',
    clidren: [
      {
        label: '<span>AQI</span>',
        type: 'AQI',
        fn: 'historyLayerShow',
        param: 'AQI',
        icon: 'icon-yaoganyaoce',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>PM<sub>2.5</sub></span>',
        type: 'PM25',
        fn: 'historyLayerShow',
        param: 'pmPM25',
        icon: 'icon-daikouzhao',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>PM<sub>10</sub></span>',
        type: 'PM10',
        fn: 'historyLayerShow',
        param: 'pmPM10',
        icon: 'icon-PM',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>SO<sub>2</sub></span>',
        type: 'SO2',
        fn: 'historyLayerShow',
        param: 'pmSO2',
        icon: 'icon-SO-',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>NO<sub>2</sub></span>',
        type: 'NO2',
        fn: 'historyLayerShow',
        param: 'pmNO2',
        icon: 'icon-NO2',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>O<sub>3</sub></span>',
        type: 'O3',
        fn: 'historyLayerShow',
        param: 'pmO3',
        icon: 'icon-satellite-O3',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>CO</span>',
        type: 'CO',
        fn: 'historyLayerShow',
        param: 'pmCO',
        icon: 'icon-wuranyuan',
        parent: 'pm',
        isSelected: false,
      },
      {
        label: '<span>TVOC</span>',
        type: 'T',
        fn: 'historyLayerShow',
        param: 'pmTVOC',
        icon: 'icon-wuranyuan',
        parent: 'pm',
        isSelected: false,
      },
    ],
  },
  {
    label: '雷达',
    type: 'radar',
    key: 2,
    param: 'radar',
    fn: 'radarDataShow',
    icon: 'icon-radar',
    isSelected: false,
  },
  {
    label: '气象',
    type: 'weatherForecast',
    key: 3,
    icon: 'icon-qixiang',
    clidren: [
      {
        label: '气温',
        type: 'TEM',
        param: 'TEM',
        icon: 'icon-qiwen',
        parent: 'weatherForecast',
        isSelected: false,
      },
      // type根据后端字段有调整 原先为'PRE'
      {
        label: '气压',
        type: 'PRS',
        param: 'PRS',
        icon: 'icon-qiya',
        parent: 'weatherForecast',
        isSelected: false,
      },
      {
        label: '湿度',
        type: 'RHU',
        param: 'humidity',
        icon: 'icon-shidu',
        parent: 'weatherForecast',
        isSelected: false,
      },
      // type根据后端字段有调整 原先为'RAIN'
      {
        label: '降水',
        type: 'PRE',
        param: 'pre_1h',
        icon: 'icon-jiangshui',
        parent: 'weatherForecast',
        isSelected: false,
      },
    ],
  },
  {
    label: '沙尘',
    type: 'dust',
    key: 4,
    icon: 'icon-diqiu',
    clidren: [
      {
        label: '<span>伪彩色图</span>',
        type: 'DSTRGB',
        param: 'DSTRGB',
        icon: 'icon-yaoganyaoce',
        parent: 'dust',
        isSelected: false,
      },
      {
        label: '<span>沙尘判识</span>',
        type: 'DSTDET',
        param: 'DSTDET',
        icon: 'icon-daikouzhao',
        parent: 'dust',
        isSelected: false,
      },
      {
        label: '<span>沙尘强度</span>',
        type: 'DSTSIL',
        param: 'DSTSIL',
        icon: 'icon-PM',
        parent: 'dust',
        isSelected: false,
      },
    ],
  },
];
